<template>
  <div class="drug_input">
    <div class="ucard_body">
      <div class="u_head">
        <div class="u_bz">
          <div class="ts_dz">
            <div class="selectGroup1">
              <div class="label">
                {{
                  prescriptionInfo.planInfo &&
                  prescriptionInfo.planInfo.planName
                    ? prescriptionInfo.planInfo.planName
                    : "中药处方"
                }}
              </div>
              <InputNumber
                :min="1"
                class="stickInput"
                v-model="prescriptionInfo.Quantity"
                @on-change="quantityChange"
              >
              </InputNumber>
              <span class="stickUnit">帖</span>
            </div>
            <div class="right">
              <Checkbox
                @on-change="teaBagFlgChange"
                v-uEdition="'YZ-34'"
                v-model="teaBagFlg"
                :disabled="
                  !!(
                    prescriptionInfo.planInfo &&
                    prescriptionInfo.planInfo.planName
                  )
                "
                >是茶包</Checkbox
              >
              <div class="follow-up-time">
                <span>
                  <Tooltip
                    v-if="patientCurrDayPreTotalQty.qty"
                    content="上次处方未到服完药时间，应复诊时间加上了上次处方贴数，请知晓！"
                    placement="left"
                    :always="alwaysTip"
                    :disabled="disabledTip"
                  >
                    <Icon
                      @click="alwaysTipFun"
                      class="returnVisitDateTip"
                      type="md-alert"
                    />
                  </Tooltip>
                  应复诊时间
                </span>
                <DatePicker
                  :options="options3"
                  v-model="prescriptionInfo.returnVisitDate"
                  type="date"
                  placeholder="请选择"
                  style="width: 120px"
                  placement="bottom-end"
                  :clearable="false"
                ></DatePicker>
              </div>
              <Button
                class="more_cf"
                @click="onMore"
                type="text"
                v-if="recordSymptom && recordSymptom.length > 1 && !hideAi"
                >更多处方</Button
              >
            </div>
          </div>
          <div
            class="tip"
            v-if="
              prescriptionInfo.planInfo && prescriptionInfo.planInfo?.planExplain
            "
          >
            治疗思路：{{ prescriptionInfo.planInfo.planExplain }}
          </div>
        </div>
      </div>
      <drug-table
        :pageType="pageType"
        :tabooDrugIds="tabooDrugIds"
        ref="drugTable"
        @change="change"
        @modifyDrug="modifyDrug"
        :stick="prescriptionInfo.Quantity"
        :drugList="prescriptionInfo.drugList"
        :tabooDrugList="tabooDrugList"
      />

      <!-- 暂时关闭 -->
      <!-- 
      <div class="taboo add-drug-taboo">
        <div class="title">
          <Tooltip
            content="处方中可能与患者的辨证产生禁忌的加药，在此处提醒说明，需点击确认使用，方可提交处方。"
            placement="right-start"
          >
            <span>
              用药禁忌
              <Icon type="ios-information-circle-outline" />
            </span>
          </Tooltip>
          <Button
            v-if="tabooDiscriminateList.length"
            :type="tabooSwitch ? 'error' : 'default'"
            size="small"
            @click="tabooBtnChange"
            >{{ tabooSwitch ? "确认使用" : "取消确认" }}</Button
          >
        </div>
        <div class="taboo-body">
          <Tabs v-if="tabooDiscriminateList.length">
            <TabPane
              v-for="(item, index) in tabooDiscriminateList"
              :key="index"
              :label="labelFormat(item)"
            >
              <div>
                <span class="text-red">{{ item.drugName }}</span>
                <span>与患者可能的辨证</span>
                <span class="text-red">{{ item.discriminatesStr }}</span>
                <span>,发生禁忌</span>
              </div>
              <div>
                典籍记载：<span class="text-heavy">{{ item.drugTaboo }}</span>
              </div>
            </TabPane>
          </Tabs>
          <empty v-else text="暂无内容" />
        </div>
      </div>
      -->
      <div class="unreferencedReason" v-if="showunreferencedReason">
        <div class="title">请简述未引用咨询处方的原因</div>
        <Input :class="{'jzmding': jzmding1}" ref="unreferencedReasonRef" v-model="prescriptionInfo.unreferencedReason" placeholder="请输入原因" />
      </div>

      <template v-if="!hideTaboo">
        <contraindications
          :info="info"
          :drugList="prescriptionInfo.drugList"
          @tabooDrugList="setTabooDrugList"
        />
        <textMore title="医嘱" :html="tabooMerge" />
        <textMore title="饮食宜进" :html="yinShiList" />
        <textMore title="饮食禁忌" :html="jiKouList" />
      </template>
    </div>
    <prescriptionSelect
      v-if="pageType"
      @change="changePrescriptionSelect"
      :list="recordSymptom"
      ref="pSelect"
    />
    <tabooPrint
      v-model="tabooPrintShow"
      :info="info"
      :taboo="{ yinShiList, jiKouList }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import drugTable from "./drugTable.vue";
import textMore from "./textMore.vue";
import tabooPrint from "./tabooPrint.vue";
import dayjs from "dayjs";
import contraindications from "./contraindications.vue";
export default {
  components: { drugTable, textMore, tabooPrint, contraindications },
  computed: {
    ...mapGetters([
      "hideAi",
      "tabooDiscriminate",
      "addMedicalRecordSymptom",
      "spinShow", //处方加载动画开关
      "hundredDrugs",
      "userSystemConfig",
      "GENERAL_DOCTOR_ADVICE",
      "savePrescription",
    ]),
    prescription() {
      return this.savePrescription[this.info.registerCode] || {};
    },
    recordSymptom() {
      return this.addMedicalRecordSymptom[this.info.registerCode] || [];
    },
    showunreferencedReason(){
      return this.recordSymptom.filter(item => item.planInfo?.planName).length > 0 && !this.prescriptionInfo.planInfo?.planName && this.prescriptionInfo.drugList.length
      // return this.recordSymptom.length > 1 && !this.prescriptionInfo.planInfo?.planExplain && this.prescriptionInfo.drugList.length
    }
  },
  watch: {
    userSystemConfig: {
      handler: function () {
        this.photoReminder = this.userSystemConfig.mrScanRemindVisited;
      },
      deep: true,
    },
    info() {
      this.init();
      this.setList();
    },
    tabooDiscriminate: {
      handler: function () {
        this.setList();
      },
      deep: true,
    },
  },
  props: {
    prescriptionInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //页面类型  true:前端医生 false:后端医生
    pageType: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 导入处方
    insertDrugFun: {
      type: Function,
      default: () => {},
    },
    //ai返回的禁忌信息
    drugtaboo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      jzmding1: false,
      hideTaboo: false,
      teaBagFlg: false,
      tabooDrugList: [], //辨证禁忌药品列表
      disabledTip: false,
      alwaysTip: true,
      patientCurrDayPreTotalQty: {
        visitDateTime: "",
        qty: 0,
      }, //患者当天已开处方总数量
      tabooPrintShow: false,
      tabooDiscriminateList: [],
      tabooSwitch: true, //禁忌开头
      tabooDrugIds: [],
      tabooMerge: "",
      doctorsAdvice: "",
      medicalAdviceSwitch: false,
      resDrugTaboo: [],
      tabooStr: "",
      btnDisabled: false, //提交按钮禁用开关
      confirm: false,
      photoReminder: false, //病历拍照提醒

      jiKouList: "",
      yinShiList: "",

      options3: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now();
        },
      },
    };
  },
  methods: {
    teaBagFlgChange(val) {
      this.$emit("teaBagFlgChange", val);
    },
    setTabooDrugList(list) {
      this.tabooDrugList = list;
    },
    changePrescriptionSelect(res) {
      this.insertDrugFun(res);
    },
    getMedicalExpertisePlanDrug() {
      this.request
        .post("/zhbusiness/getMedicalExpertisePlanDrug", {
          diseaseCode: this.info.diagnosticId2, //	病种Code
          patientCode: this.info.patientCode, //	患者编码
        })
        .then((res) => {
          let list = res.result
            .filter((i) => {
              return i.meType == 1; // 1 咨询 2 预备方案
            })
            .reverse();

          list.forEach((item) => {
            if (item.medicalRecordInfo != "[]") {
              let name = item.planName;
              if (name.indexOf("病情") != -1) {
                name += "方案";
              }
              this.$store.commit("addMedicalRecordSymptom_add", {
                isShift: true,
                id: this.info.registerCode,
                data: {
                  planInfo: item,
                  title: name,
                  remark: name,
                  active: false,
                  drugsList: JSON.parse(item.medicalRecordInfo).map((i) => {
                    i.drugCode = i.Drug_Code;
                    i.amount = i.Amount;
                    return i;
                  }),
                },
              });
            }
          });
          if (list.length && !this.hideAi) {
            this.insertDrugFun(this.recordSymptom[0]);
          }
        });
    },
    // 保存处方修改过程
    modifyDrug(res) {
      let key = `modifyDrug-${this.info.registerCode}`;
      let list = [];
      let oldData = localStorage.getItem(key);
      if (oldData) {
        list = JSON.parse(oldData);
      }
      list.push(res);
      localStorage.setItem(key, JSON.stringify(list));
    },
    alwaysTipFun() {
      this.alwaysTip = false;
      this.disabledTip = true;
      setTimeout(() => {
        this.disabledTip = false;
      }, 1000);
    },
    tabooPrint() {
      this.tabooPrintShow = true;
    },
    tabooBtnChange() {
      this.tabooSwitch = !this.tabooSwitch;
      if (!this.tabooSwitch) {
        let obj = {
          prescriptionNo: this.info.prescriptionNo, //处方号
          patientCode: this.info.patientCode, //病人编码
          drugDialecticsInfo: JSON.stringify(this.tabooDiscriminateList), //药物禁忌辨证json串
          symptomNo: this.info.symptomNo, //病历号
        };
        this.api2("saveDrugTabooByDiscriminateLog", obj).then((res) => {});
      }
    },
    setList() {
      // 暂时关闭
      // return;
      let list = this.tabooDiscriminate[this.info.registerCode] || [];
      this.tabooDrugIds = list.map((i) => i.drugCode);
      if (
        list.length &&
        this.prescriptionInfo.drugList &&
        this.prescriptionInfo.drugList.length
      ) {
        let ids = this.prescriptionInfo.drugList.map((i) => i.Drug_Code);
        this.tabooDiscriminateList = list.filter((i) =>
          ids.includes(i.drugCode)
        );
      } else {
        this.tabooDiscriminateList = [];
      }
    },
    labelFormat(item) {
      return (h) => {
        return h("div", [
          h(
            "i",
            {
              class: "",
            },
            "禁"
          ),
          h("span", item.drugName),
        ]);
      };
    },
    onMedicalAdviceSwitch() {
      this.medicalAdviceSwitch = !this.medicalAdviceSwitch;
    },
    onMore() {
      this.$refs.pSelect.onShow();
    },
    // 验证
    async validate() {
      if(this.showunreferencedReason && !this.prescriptionInfo.unreferencedReason) {
        this.$Message.error("请输入简述未引用咨询处方的原因");
        let node = this.$refs.unreferencedReasonRef
        node.focus();
        this.jzmding1 = true;
        setTimeout(() => {
          this.jzmding1 = false;
        }, 1000);
        return;
      }

      if(this.showunreferencedReason && this.prescriptionInfo.unreferencedReason) {
        let item = this.recordSymptom[0].planInfo || {}
        this.prescriptionInfo.merId = item.merId;
        this.prescriptionInfo.meId = item.meId;
      }else{
        this.prescriptionInfo.merId = "";
        this.prescriptionInfo.meId = "";
        this.prescriptionInfo.unreferencedReason = "";
      }

      if (!this.prescriptionInfo.drugList.length) {
        this.$Message.error("请先开好处方再提交!");
        return;
      }
      if (!this.$refs.drugTable.cj_drugList()) {
        return;
      }

      //暂时关闭
      if (this.tabooDiscriminateList.length) {
        if (this.tabooSwitch) {
          this.$store.commit("setN_tip", {
            title: "提示",
            okText: "确认使用",
            onOk: () => {
              this.tabooBtnChange();
            },
            content: "有未被确认的加药禁忌",
          });
          return;
        }
      }

      // 是否病历拍照
      if (this.photoReminder && this.pageType) {
        let obj = {
          patientCode: this.info.patientCode,
          registerCode: this.info.registerCode,
          picType: 0,
        };

        this.photoReminder = false;
        let res = await this.api2("queryMedicalRecordScan", obj);
        if (!res.result.length) {
          this.$store.commit("setN_tip", {
            title: "提示",
            content: "病历还没有扫描哦",
          });
          return;
        }
      }

      // 检查是否禁忌药
      let flog = await this.$refs.drugTable.validataTaboo();
      if (!flog) {
        return false;
      }

      return true;
    },
    getRecallAndDrugTaboo() {
      let obj = {
        patientCode: this.info.patientCode,
        symptomNo: this.info.symptomNo,
        dsIds: this.info.symptom.map((i) => i.dsId).join("|"),
      };
      this.$store.commit("openSpin");
      this.api2("getRecallAndDrugTaboo", obj).then((res) => {
        this.$store.commit("closeSpin");
        this.resDrugTaboo = res.result.drugTaboo;
        this.doctorsAdvice = res.result.doctorsAdvice;
        this.$store.commit("setIsRecall", res.result.isRecall);
        this.setTaboos();
      });
    },
    change() {
      this.$emit("change");
      this.setList();
      this.setTaboos();
    },
    // 更新禁忌
    setTaboos() {
      this.tabooStr = "";
      this.prescriptionInfo.drugList.forEach((i, index) => {
        let item = this.hundredDrugs.find((j) => j.Drug_Code == i.Drug_Code);
        if (item && item.drugtaboo) {
          this.tabooStr += " " + item.drugtaboo;
        }
      });

      if (!this.tabooStr) {
        this.tabooStr = this.drugtaboo;
      }

      this.tabooMerge = this.common.tabooFormat(
        this.GENERAL_DOCTOR_ADVICE.join(" ") +
          this.tabooStr +
          (this.doctorsAdvice || "")
      );

      this.$emit("tabooChange", this.tabooMerge);

      if (!(this.resDrugTaboo && this.resDrugTaboo.length)) return;

      if (this.info.symptom.length) {
        // 禁忌药品数据格式化
        let list = this.common.formatTaboo(
          this.common.clone(this.resDrugTaboo),
          this.info.symptom
        );
        this.prescriptionInfo.drugList.forEach((i) => {
          let item = list.find((j) => j.drugCode == i.Drug_Code);
          if (item) {
            let tabooDetailList = item.tabooDetailList;
            let type3 = tabooDetailList.find((k) => k.tabooType == 3);
            if (type3 && type3.dosageTaboo >= i.Amount) {
              tabooDetailList = tabooDetailList.filter((k) => k.tabooType != 3);
            }
            i.drugTaboo = tabooDetailList;
            i.error = tabooDetailList.find((k) => k.tabooType == 0)
              ? true
              : false;
          } else {
            i.drugTaboo = [];
          }
        });
      }
    },

    listDiseaseDietPlan() {
      let obj = {
        dsIds: this.info.diagnosticId2,
      };
      this.$store.commit("openSpin");
      this.api2("listDiseaseDietPlan", obj).then((res) => {
        this.$store.commit("closeSpin");
        this.jiKouList = res.result.jiKouList
          ? this.common.tabooFormat(
              res.result.jiKouList.map((i) => i.jiKouName).join(" ")
            )
          : "";
        this.yinShiList = res.result.yinShiList
          ? this.common.tabooFormat(
              res.result.yinShiList.map((i) => i.yinShiName).join(" ")
            )
          : "";
      });
    },

    getPatientCurrDayPreTotalQty() {
      this.patientCurrDayPreTotalQty.qty = 0;
      this.api2("getPatientCurrDayPreTotalQty", {
        billNo: this.info.prescriptionNo, //	单号
        hospitalCode: this.info.hospitalCode, //	医馆编码
        patientCode: this.info.patientCode, //	病人编码
      })
        .then((res) => {
          this.patientCurrDayPreTotalQty = res.result;
        })
        .finally(() => {
          this.quantityChange();
        });
    },

    quantityChange() {
      if (!this.prescriptionInfo.Quantity) return;
      /*if (this.info.isInternetHospital && this.prescriptionInfo.Quantity > 7) {
        this.$Message.warning("应互联网监管要求，处方贴数不得超过7帖");
        this.prescriptionInfo.Quantity = 7;
      }*/
      let n = 0;
      if (this.patientCurrDayPreTotalQty.qty) {
        let od =
          dayjs().diff(this.patientCurrDayPreTotalQty.visitDateTime, "day") + 1;
        n = this.patientCurrDayPreTotalQty.qty - od;
        if (n < 0) n = 0;
      }

      this.prescriptionInfo.returnVisitDate = dayjs()
        .add(this.prescriptionInfo.Quantity * 1 - 1 + n, "day")
        .format("YYYY-MM-DD");
      let d = dayjs()
        .add(this.prescriptionInfo.Quantity * 1 + 29, "day")
        .toDate();
      this.options3 = {
        disabledDate(date) {
          return !(date.valueOf() > Date.now() && date.valueOf() < d.valueOf());
        },
      };
    },

    getDietaryPlan() {
      let meal = ["", "早餐", "午餐", "晚餐"];
      let obj = {
        diseaseType: this.info.diagnosticId2,
        userSex: this.info.sex == "男" ? 1 : 2,
      };
      this.$store.commit("openSpin");
      this.api2("getDietaryPlan", obj).then((res) => {
        this.$store.commit("closeSpin");

        let str = "";
        let taboo = res.result.taboo;
        for (const key in taboo) {
          if (Object.hasOwnProperty.call(taboo, key)) {
            const item = taboo[key];
            str += `<div class="taboo-item"><span>${key}：</span> ${item.join(
              ", "
            )}</div>`;
          }
        }
        this.jiKouList = str;
        this.yinShiList = res.result.suitable
          .map((i) => {
            return `<div class="taboo-item"><span>${
              meal[i.planThreeMeal]
            }：</span> ${i.foodsName}</div>`;
          })
          .join(" ");
      });
    },

    setTeaBagFlg() {
      this.teaBagFlg = this.prescriptionInfo.teaBagFlg;
    },

    init() {
      this.hideTaboo = this.hideAi;
      this.listDiseaseDietPlan();
      this.getRecallAndDrugTaboo();
      this.photoReminder = this.userSystemConfig.mrScanRemindVisited;
      this.btnDisabled = false;
      this.confirm = false;
      this.tabooSwitch = true;
      this.$store.commit("initN_tip");
      this.getPatientCurrDayPreTotalQty();

      // 测试
      // this.getMedicalExpertisePlanDrug();
      // return

      if (
        this.prescription &&
        this.prescription.drugList &&
        this.prescription.drugList.length
      ) {
        this.$nextTick(() => {
          this.$bus.emit("setPrescriptionSelectActive", this.prescription.drugList.map((i) => i.Drug_Code));
        });
      } else {
        this.getMedicalExpertisePlanDrug();
      }
    },
  },
  mounted() {
    this.init();
    this.$bus.on("HIDEAI", (data) => {
      switch (data) {
        case "yizhujinji":
          this.hideTaboo = false;
          break;
        case "tuijianchufang":
          if(this.$refs.pSelect) this.$refs.pSelect.onShow();
          break;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.selectGroup1 {
  display: flex;
  line-height: 32px;

  .label {
    padding-right: 30px;
    font-weight: bold;
  }

  .stickInput {
    width: 80px;
    height: 32px;
  }
}

.drug_input {
  height: 100%;
  overflow: hidden;
  position: relative;
}

::v-deep .taboo-item {
  span {
    font-weight: bold;
  }
}

.taboo {
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 5px;

  .title {
    font-weight: bold;
    padding-bottom: 0;
  }

  .taboo-text {
    line-height: 26px;
    height: 50px;
    overflow: hidden;

    &-more {
      height: auto;
    }
  }
}

.u_table2 {
  margin-bottom: 10px;
}
.ts_dz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .follow-up-time,
  .right {
    display: flex;
    align-items: start;
  }
  .follow-up-time {
    & > span {
      padding-right: 10px;
    }
    .ivu-tooltip {
      :deep {
        .ivu-tooltip-popper {
          z-index: 1 !important;
        }
      }
    }
  }
}
.returnVisitDateTip {
  cursor: pointer;
}
.drug_input {
  .tip {
    font-size: 12px;
    margin-bottom: 5px;
  }
}
.stickUnit {
  padding: 4px 7px;
  font-size: inherit;
  font-weight: 400;
  color: #515a6e;
  text-align: center;
  background-color: #f8f8f9;
  border: 1px solid #dcdee2;
  border-radius: 4px;

  line-height: 28px;
  height: 32px;
  padding: 0 10px;
}
.unreferencedReason{
  background: #fff6eb;
  color: #b95917;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 5px;
  :deep{
    .ivu-input{
      border-color: #b95917;
    }
  }
}
</style>
